import { jsx as _jsx } from 'react/jsx-runtime.js';
import { DialogDismissButton, Flex } from '@stepstone-genesis/components';
export const CloseModalButton = ({ onClick }) => {
    return (_jsx(Flex, { flxJustify: "flex-end", sx: {
            position: 'relative',
            zIndex: 'zIndex20',
        }, children: _jsx(DialogDismissButton, { a11yLabel: "Dismiss dialog", onClick: onClick, mt: ['24px', '16px'], mr: ['20px', '12px'], sx: {
                position: 'absolute',
                zIndex: 'zIndex10',
                '& > span > span > span': {
                    width: ['23px', '32px', '32px'],
                    height: ['23px', '32px', '32px'],
                },
            } }) }));
};
//# sourceMappingURL=CloseModalButton.js.map